(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[289],{

/***/ 49469:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strumenti-servizi/tailor-made",
      function () {
        return __webpack_require__(40158);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var FormFile = function(param) {
    var id = param.id, name = param.name, className = param.className, placeholder = param.placeholder, disabled = param.disabled, value = param.value, onChange = param.onChange, checked = param.checked, readOnly = param.readOnly, filename = param.filename, icon = param.icon, iconPos = param.iconPos, size = param.size, accept = param.accept;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: 'formfile' + (disabled ? ' formfile--disabled' : '') + (size ? ' formfile--' + size : ' formfile--md') + (className ? ' ' + className : ''),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            className: "formfile__input-wrap",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    checked: checked,
                    name: name,
                    id: id,
                    value: value,
                    className: "formfile__input",
                    type: "file",
                    disabled: disabled,
                    onChange: onChange,
                    readOnly: readOnly,
                    accept: accept
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "formfile__content",
                    children: [
                        icon && iconPos === 'left' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "formfile__icon",
                            children: icon
                        }),
                        filename ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "formfile__filename",
                            children: filename
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "formfile__label",
                            children: placeholder ? placeholder : ''
                        }),
                        icon && iconPos !== 'left' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "formfile__icon",
                            children: icon
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FormFile);


/***/ }),

/***/ 31452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _atoms_NewIcons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20474);



var QuantityHandler = function(param) {
    var value = param.value, onValueChange = param.onValueChange, inputDisabled = param.inputDisabled;
    // Se è settato onValueChange, il value è gestito esternamente
    // altrimenti si usa lo state (es. storybook)
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(value), stateVal = ref[0], setStateVal = ref[1];
    var getVal = function() {
        return onValueChange ? value : stateVal;
    };
    var changeVal = function(newVal, action) {
        onValueChange ? onValueChange(newVal, action) : setStateVal(newVal);
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "quantity-handler",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "quantity-handler__button quantity-handler__button--minus",
                onClick: function() {
                    return changeVal(getVal() - 1, 'remove');
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_NewIcons__WEBPACK_IMPORTED_MODULE_2__/* .Minus */ .WF, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                className: "quantity-handler__input",
                value: getVal() || '',
                onChange: function(e) {
                    return changeVal(parseInt(e.target.value), 'set' || 0);
                },
                disabled: inputDisabled,
                placeholder: "0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "quantity-handler__button quantity-handler__button--plus",
                onClick: function() {
                    return changeVal(getVal() + 1, 'add');
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_NewIcons__WEBPACK_IMPORTED_MODULE_2__/* .Plus */ .v3, {})
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(QuantityHandler));


/***/ }),

/***/ 59231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useAutocomplete; }
/* harmony export */ });
/* harmony import */ var _code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var downshift__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88942);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44043);
/* harmony import */ var _atoms_FormInput_FormInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32695);
/* harmony import */ var _atoms_Loading_Loading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4674);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85313);








function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AutoComplete = function(param1) {
    var label = param1.label, placeholder = param1.placeholder, inputFromProps = param1.inputFromProps, itemsFromProps = param1.items, onChange = param1.onChange, async = param1.async, limit = param1.limit, loading = param1.loading, onBlur = param1.onBlur, status = param1.status, errorMessage = param1.errorMessage, customInput = param1.customInput, onlyOptionsInput = param1.onlyOptionsInput;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(itemsFromProps ? itemsFromProps : []), items = ref[0], setItems = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), input = ref1[0], setInput = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        inputFromProps && setInput(inputFromProps);
    }, [
        inputFromProps
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        async && setItems(itemsFromProps);
    }, [
        itemsFromProps
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(downshift__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        onInputValueChange: function(inputValue) {
            return onChange && (onChange(inputValue), setInput(inputValue));
        },
        onChange: function(selection) {
            setInput(selection === null || selection === void 0 ? void 0 : selection.value);
            onChange && onChange(selection === null || selection === void 0 ? void 0 : selection.value, selection);
        },
        itemToString: function(item) {
            return onlyOptionsInput ? item ? item.value : '' : item ? input === (item === null || item === void 0 ? void 0 : item.value) ? item === null || item === void 0 ? void 0 : item.value : input : input;
        },
        children: function(param) {
            var getInputProps = param.getInputProps, getItemProps = param.getItemProps, getLabelProps = param.getLabelProps, getMenuProps = param.getMenuProps, getToggleButtonProps = param.getToggleButtonProps, isOpen = param.isOpen, inputValue = param.inputValue, highlightedIndex = param.highlightedIndex, selectedItem = param.selectedItem, getRootProps = param.getRootProps;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "autocomplete",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_3__/* .FormField */ .Wi, _objectSpread({}, getLabelProps(), {
                        label: label,
                        errorMessage: errorMessage,
                        status: status,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", _objectSpread({}, getRootProps({}, {
                            suppressRefError: true
                        }), getToggleButtonProps(), {
                            children: customInput ? customInput : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms_FormInput_FormInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({
                                onBlur: onBlur
                            }, getInputProps({
                                value: inputFromProps === undefined ? input ? input : '' : inputFromProps
                            }), {
                                placeholder: placeholder
                            }))
                        }))
                    })),
                    items !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", _objectSpread({}, getMenuProps(), {
                        className: "autocomplete__items",
                        children: isOpen ? loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms_Loading_Loading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            width: 20
                        }) : (items === null || items === void 0 ? void 0 : items.length) > 0 && (items === null || items === void 0 ? void 0 : items.filter(function(item) {
                            return !inputValue || item.value.includes(inputValue);
                        }).slice(0, limit ? limit : items === null || items === void 0 ? void 0 : items.length).map(function(item, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", _objectSpread({}, getItemProps({
                                autoComplete: true,
                                key: item.value,
                                index: index,
                                item: item,
                                style: {
                                    cursor: 'pointer',
                                    backgroundColor: highlightedIndex === index ? 'lightgray' : 'white',
                                    fontWeight: selectedItem === item ? 'bold' : 'normal'
                                }
                            }), {
                                children: item.value
                            }));
                        })) : null
                    }))
                ]
            });
        }
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AutoComplete);
// Custom Hook per rendere pulito tailormade
var useAutocomplete = function(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), data = ref3[0], setData = ref3[1];
    var _fetchItems = function() {
        var _ref = _asyncToGenerator(_code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(input, product) {
            var params;
            return _code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        params = {
                            q: input,
                            product: product
                        };
                        _ctx.next = 4;
                        return _utils__WEBPACK_IMPORTED_MODULE_6__/* .api.get */ .hi.get("/autocomplete/", {
                            params: params
                        }).then(function(res) {
                            setData(res === null || res === void 0 ? void 0 : res.data);
                            setLoading(false);
                        }).catch(function(err) {
                            setError(err === null || err === void 0 ? void 0 : err.message), setLoading(false);
                        });
                    case 4:
                        setLoading(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function _fetchItems(input, product) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var timeout = setTimeout(function() {
            value && _fetchItems(value);
        }, 500);
        return function() {
            return clearTimeout(timeout), setLoading(false);
        };
    }, [
        value
    ]);
    var fetchItems = function() {
        var _ref = _asyncToGenerator(_code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(input) {
            var product, _args = arguments;
            return _code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        product = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 0;
                        setLoading(true);
                        _ctx.next = 4;
                        return _fetchItems(input, product);
                    case 4:
                        setLoading(false);
                        return _ctx.abrupt("return", data);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchItems(input) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        data: data,
        loading: loading,
        error: error,
        fetchItems: fetchItems
    };
};


/***/ }),

/***/ 46612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ usePrivacy; }
/* harmony export */ });
/* harmony import */ var _code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85313);
/* harmony import */ var _utils_endpoint__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8646);






function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var usePrivacy = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), InformativaPrivacy = ref2[0], setInformativaPrivacy = ref2[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), condizioniGenerali = ref1[0], setCondizioniGenerali = ref1[1];
    var locale = router.locale;
    var privacy = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.privacy;
    }).privacy;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        getInformativaPrivacy();
        getCondizioniGenerali();
    }, [
        router.isReady
    ]);
    var getUrlInformativaFromStore = function() {
        var ref;
        return privacy === null || privacy === void 0 ? void 0 : (ref = privacy.seo) === null || ref === void 0 ? void 0 : ref.canonical_url;
    };
    var getUrlInformativa = function() {
        var ref;
        return InformativaPrivacy === null || InformativaPrivacy === void 0 ? void 0 : (ref = InformativaPrivacy.seo) === null || ref === void 0 ? void 0 : ref.canonical_url;
    };
    var getUrlCondizioniGenerali = function() {
        var ref;
        return condizioniGenerali === null || condizioniGenerali === void 0 ? void 0 : (ref = condizioniGenerali.seo) === null || ref === void 0 ? void 0 : ref.canonical_url;
    };
    var getInformativaPrivacy = function() {
        var _ref = _asyncToGenerator(_code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var data;
            return _code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _utils__WEBPACK_IMPORTED_MODULE_4__/* .api.get */ .hi.get(_utils_endpoint__WEBPACK_IMPORTED_MODULE_5__/* .PAGINEDETAIL */ .IR, {
                            params: {
                                chiave: 'informativa-privacy',
                                lang: locale
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        setInformativaPrivacy(data);
                        return _ctx.abrupt("return", data);
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {});
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function getInformativaPrivacy() {
            return _ref.apply(this, arguments);
        };
    }();
    var getCondizioniGenerali = function() {
        var _ref = _asyncToGenerator(_code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var data;
            return _code_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _utils__WEBPACK_IMPORTED_MODULE_4__/* .api.get */ .hi.get(_utils_endpoint__WEBPACK_IMPORTED_MODULE_5__/* .PAGINEDETAIL */ .IR, {
                            params: {
                                chiave: 'condizioni-servizio',
                                lang: locale
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        setCondizioniGenerali(data);
                        return _ctx.abrupt("return", data);
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {});
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function getCondizioniGenerali() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        getCondizioniGenerali: getCondizioniGenerali,
        getInformativaPrivacy: getInformativaPrivacy,
        InformativaPrivacy: InformativaPrivacy,
        condizioniGenerali: condizioniGenerali,
        getUrlInformativaFromStore: getUrlInformativaFromStore,
        getUrlInformativa: getUrlInformativa,
        getUrlCondizioniGenerali: getUrlCondizioniGenerali
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (usePrivacy);


/***/ }),

/***/ 40158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ tailor_made; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/atoms/Loading/Loading.js
var Loading = __webpack_require__(4674);
// EXTERNAL MODULE: ./components/organisms/ModalLogin/ModalLogin.js
var ModalLogin = __webpack_require__(26426);
// EXTERNAL MODULE: ./hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(57080);
// EXTERNAL MODULE: ./components/atoms/index.js + 2 modules
var atoms = __webpack_require__(44043);
// EXTERNAL MODULE: ./components/molecules/index.js + 19 modules
var molecules = __webpack_require__(36068);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 6 modules
var formik_esm = __webpack_require__(97393);
// EXTERNAL MODULE: ./components/atoms/FormField/FormField.js
var FormField = __webpack_require__(57260);
// EXTERNAL MODULE: ./components/atoms/FormInput/FormInput.js
var FormInput = __webpack_require__(32695);
// EXTERNAL MODULE: ./components/atoms/FormFile/FormFile.js
var FormFile = __webpack_require__(3215);
// EXTERNAL MODULE: ./components/atoms/QuantityHandler/QuantityHandler.js
var QuantityHandler = __webpack_require__(31452);
// EXTERNAL MODULE: ./components/atoms/Button/Button.js
var Button = __webpack_require__(81642);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 89 modules
var yup_es = __webpack_require__(32089);
// EXTERNAL MODULE: ./components/molecules/AutoComplete/AutoComplete.js
var AutoComplete = __webpack_require__(59231);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(85313);
// EXTERNAL MODULE: ./utils/endpoint.js
var endpoint = __webpack_require__(8646);
// EXTERNAL MODULE: ./components/atoms/Notifica/Notifica.js + 2 modules
var Notifica = __webpack_require__(83729);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./hooks/useTrans.js
var useTrans = __webpack_require__(49896);
// EXTERNAL MODULE: ./hooks/usePrivacy.jsx
var usePrivacy = __webpack_require__(46612);
;// CONCATENATED MODULE: ./components/organisms/FormTailorMade/FormTailorMade.js


















var validationSchema = function(t) {
    return yup_es/* object */.Ry().shape({
        email: yup_es/* string */.Z_().email(t("L'email deve essere valida")).required(t('Questo campo \xe8 obbligatorio')).nullable(),
        telefono: yup_es/* string */.Z_().required(t('Questo campo \xe8 obbligatorio')).nullable(),
        nome: yup_es/* string */.Z_().required(t('Questo campo \xe8 obbligatorio')).nullable(),
        cognome: yup_es/* string */.Z_().required(t('Questo campo \xe8 obbligatorio')).nullable(),
        prezzo_target: yup_es/* number */.Rx().typeError(t('Questo campo deve essere numerico')).nullable()
    });
};
var FormTailorMade = function() {
    var utente = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.utente;
    }).utente;
    var ref5 = (0,react.useState)(), LogoFile = ref5[0], setLogoFile = ref5[1];
    var ref1 = (0,react.useState)([]), items = ref1[0], setItems = ref1[1];
    var ref2 = (0,react.useState)({}), datiAzienda = ref2[0], setDatiAzienda = ref2[1];
    var ref3 = (0,AutoComplete/* useAutocomplete */.o)(), data1 = ref3.data, loading = ref3.loading, error = ref3.error, fetchItems = ref3.fetchItems;
    var router = (0,next_router.useRouter)();
    var t = (0,useTrans/* default */.Z)();
    var getUrlInformativaFromStore = (0,usePrivacy/* default */.Z)().getUrlInformativaFromStore;
    var service_gift = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.servicegift;
    }).service_gift;
    (0,react.useEffect)(function() {
        utils/* api.get */.hi.get(endpoint/* PROFILOAZIENDA */.Lc).then(function(res) {
            var ref, ref4;
            return setDatiAzienda({
                id: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.id,
                azienda: res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : ref4.ragione_sociale
            });
        }).catch(function(err) {
            return console.log(err);
        });
    }, []);
    (0,react.useEffect)(function() {}, [
        items
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        enableReinitialize: true,
        initialValues: {
            nome: utente === null || utente === void 0 ? void 0 : utente.nome,
            cognome: utente === null || utente === void 0 ? void 0 : utente.cognome,
            email: utente === null || utente === void 0 ? void 0 : utente.email,
            telefono: utente === null || utente === void 0 ? void 0 : utente.telefono,
            codice_prodotto: null,
            quantita: 0,
            descrizione_articolo: null,
            dimensione_articolo: null,
            materiale_articolo: null,
            tecnica_stampa: null,
            numero_colori: null,
            dimensione_logo: null,
            colore: null,
            logo: null,
            data_consegna: null,
            prezzo_target: null
        },
        validationSchema: validationSchema(t),
        isInitialValid: false,
        onSubmit: function(values, param) {
            var resetForm = param.resetForm;
            var data = new FormData();
            data.append('anagrafica_azienda', utente === null || utente === void 0 ? void 0 : utente.anagrafica_azienda_codice);
            data.append('azienda', datiAzienda === null || datiAzienda === void 0 ? void 0 : datiAzienda.azienda);
            data.append('nome', values === null || values === void 0 ? void 0 : values.nome);
            data.append('cognome', values === null || values === void 0 ? void 0 : values.cognome);
            data.append('email', values === null || values === void 0 ? void 0 : values.email);
            data.append('telefono', values === null || values === void 0 ? void 0 : values.telefono);
            (values === null || values === void 0 ? void 0 : values.descrizione_articolo) && data.append('descrizione_articolo', values === null || values === void 0 ? void 0 : values.descrizione_articolo);
            (values === null || values === void 0 ? void 0 : values.codice_prodotto) && data.append('codice_articolo', values === null || values === void 0 ? void 0 : values.codice_prodotto);
            (values === null || values === void 0 ? void 0 : values.dimensione_articolo) && data.append('dimensione_articolo', values === null || values === void 0 ? void 0 : values.dimensione_articolo);
            (values === null || values === void 0 ? void 0 : values.materiale_articolo) && data.append('materiale_articolo', values === null || values === void 0 ? void 0 : values.materiale_articolo);
            (values === null || values === void 0 ? void 0 : values.colore) && data.append('colore_articolo', values === null || values === void 0 ? void 0 : values.colore);
            (values === null || values === void 0 ? void 0 : values.tecnica_stampa) && data.append('tecnica_stampa', values === null || values === void 0 ? void 0 : values.tecnica_stampa);
            (values === null || values === void 0 ? void 0 : values.numero_colori) && data.append('numero_colori', values === null || values === void 0 ? void 0 : values.numero_colori);
            (values === null || values === void 0 ? void 0 : values.dimensione_logo) && data.append('dimensioni_logo', values === null || values === void 0 ? void 0 : values.dimensione_logo);
            (values === null || values === void 0 ? void 0 : values.quantita) && data.append('quantita', values === null || values === void 0 ? void 0 : values.quantita);
            (values === null || values === void 0 ? void 0 : values.data_consegna) && data.append('data_consegna', values === null || values === void 0 ? void 0 : values.data_consegna);
            (values === null || values === void 0 ? void 0 : values.prezzo_target) && data.append('prezzo_target', values === null || values === void 0 ? void 0 : values.prezzo_target);
            data.append('lang', router.locale);
            LogoFile && data.append('file', LogoFile);
            utils/* api.post */.hi.post(endpoint/* RICHIESTATAYLORMADE */.qF, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Content-Disposition': 'attachment; filename=file_to_upload.file.name'
                }
            }).then(function(res) {
                res.data.upload && alert(t('Errore caricamento immagine'));
                if (!res.data.upload) {
                    router.push('/strumenti-servizi/tailor-made/success');
                    resetForm();
                }
            }).catch(function(err) {
                console.log(err);
                (0,Notifica/* displayNotification */.d)('tailor_made_error', err === null || err === void 0 ? void 0 : err.message, 'error');
            });
        },
        children: function(props) {
            var ref, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "step-tailor",
                style: {
                    marginTop: 50
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            marginBottom: 15
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                            chiave: "Compila il form per richiedere un ordine import"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "step-tailor__fieldsets",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Nome'),
                                status: ((ref = props.touched) === null || ref === void 0 ? void 0 : ref.nome) && ((ref6 = props.errors) === null || ref6 === void 0 ? void 0 : ref6.nome) ? 'error' : ((ref7 = props.touched) === null || ref7 === void 0 ? void 0 : ref7.nome) && 'success',
                                errorMessage: (ref8 = props.errors) === null || ref8 === void 0 ? void 0 : ref8.nome,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('Nome'),
                                    value: (ref9 = props.values) === null || ref9 === void 0 ? void 0 : ref9.nome,
                                    onBlur: props.handleBlur('nome'),
                                    onChange: props.handleChange('nome')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Cognome'),
                                status: ((ref10 = props.touched) === null || ref10 === void 0 ? void 0 : ref10.cognome) && ((ref11 = props.errors) === null || ref11 === void 0 ? void 0 : ref11.cognome) ? 'error' : ((ref12 = props.touched) === null || ref12 === void 0 ? void 0 : ref12.cognome) && 'success',
                                errorMessage: (ref13 = props.errors) === null || ref13 === void 0 ? void 0 : ref13.cognome,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('Nome e cognome'),
                                    value: (ref14 = props.values) === null || ref14 === void 0 ? void 0 : ref14.cognome,
                                    onBlur: props.handleBlur('cognome'),
                                    onChange: props.handleChange('cognome')
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "step-tailor__fieldsets",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('E-Mail'),
                                status: props.touched.email && props.errors.email ? 'error' : props.touched.email && 'success',
                                errorMessage: (ref15 = props.errors) === null || ref15 === void 0 ? void 0 : ref15.email,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('E-Mail'),
                                    value: (ref16 = props.values) === null || ref16 === void 0 ? void 0 : ref16.email,
                                    onBlur: props.handleBlur('email'),
                                    onChange: props.handleChange('email')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Telefono'),
                                status: ((ref17 = props.touched) === null || ref17 === void 0 ? void 0 : ref17.telefono) && ((ref18 = props.errors) === null || ref18 === void 0 ? void 0 : ref18.telefono) ? 'error' : ((ref19 = props.touched) === null || ref19 === void 0 ? void 0 : ref19.telefono) && 'success',
                                errorMessage: (ref20 = props.errors) === null || ref20 === void 0 ? void 0 : ref20.telefono,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('Telefono'),
                                    value: (ref21 = props.values) === null || ref21 === void 0 ? void 0 : ref21.telefono,
                                    onBlur: props.handleBlur('telefono'),
                                    onChange: props.handleChange('telefono')
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "step-tailor__fieldsets",
                        style: {
                            marginTop: 25
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoComplete/* default */.Z, {
                                    async: true,
                                    loading: loading,
                                    status: props.touched.codice_prodotto ? props.errors.codice_prodotto ? 'error' : props.touched.codice_prodotto && 'success' : null,
                                    errorMessage: (ref22 = props.errors) === null || ref22 === void 0 ? void 0 : ref22.codice_prodotto,
                                    onBlur: props.handleBlur('codice_prodotto'),
                                    onChange: function(value) {
                                        fetchItems(value);
                                        props.setFieldValue('codice_prodotto', value);
                                    },
                                    label: t('Codice prodotto'),
                                    placeholder: t('Inserisci Codice prodotto'),
                                    items: data1 === null || data1 === void 0 ? void 0 : data1.map(function(item) {
                                        return {
                                            value: item === null || item === void 0 ? void 0 : item.codice
                                        };
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Quantit\xe0'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityHandler/* default */.Z, {
                                    value: (ref23 = props.values) === null || ref23 === void 0 ? void 0 : ref23.quantita,
                                    inputDisabled: false,
                                    onValueChange: function(newVal, action) {
                                        switch(action){
                                            case 'remove':
                                            case 'add':
                                                newVal >= 0 && props.setFieldValue('quantita', newVal);
                                            case 'set':
                                                props.setFieldValue('quantita', isNaN(newVal) ? 0 : newVal);
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Descrizione Articolo'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('inserisci descrizione articolo'),
                                    value: (ref24 = props.values) === null || ref24 === void 0 ? void 0 : ref24.descrizione_articolo,
                                    onBlur: props.handleBlur('descrizione_articolo'),
                                    onChange: props.handleChange('descrizione_articolo')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Dimensione articolo'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('inserisci dimensione articolo'),
                                    value: (ref25 = props.values) === null || ref25 === void 0 ? void 0 : ref25.dimensione_articolo,
                                    onBlur: props.handleBlur('dimensione_articolo'),
                                    onChange: props.handleChange('dimensione_articolo')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Materiale articolo'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('inserisci materiale articolo'),
                                    value: (ref26 = props.values) === null || ref26 === void 0 ? void 0 : ref26.materiale_articolo,
                                    onBlur: props.handleBlur('materiale_articolo'),
                                    onChange: props.handleChange('materiale_articolo')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Tecnica di stampa'),
                                status: props.touched.colore && props.errors.colore ? 'error' : props.touched.colore && 'success',
                                errorMessage: (ref27 = props.errors) === null || ref27 === void 0 ? void 0 : ref27.colore,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('Tecnica di Stampa'),
                                    value: (ref28 = props.values) === null || ref28 === void 0 ? void 0 : ref28.tecnica_stampa,
                                    onBlur: props.handleBlur('tecnica_stampa'),
                                    onChange: props.handleChange('tecnica_stampa')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Numero di colori'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('Numero di colori'),
                                    value: (ref29 = props.values) === null || ref29 === void 0 ? void 0 : ref29.numero_colori,
                                    onBlur: props.handleBlur('numero_colori'),
                                    onChange: props.handleChange('numero_colori')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Dimensioni Logo'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('Dimensioni logo'),
                                    value: (ref30 = props.values) === null || ref30 === void 0 ? void 0 : ref30.dimensione_logo,
                                    onBlur: props.handleBlur('dimensione_logo'),
                                    onChange: props.handleChange('dimensione_logo')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Colore (Specificare se pantone)'),
                                errorMessage: (ref31 = props.errors) === null || ref31 === void 0 ? void 0 : ref31.colore,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('Inserisci il codice pantone'),
                                    value: props.values.colore,
                                    onBlur: props.handleBlur('colore'),
                                    onChange: props.handleChange('colore')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Logo'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormFile/* default */.Z, {
                                            filename: LogoFile === null || LogoFile === void 0 ? void 0 : LogoFile.name,
                                            placeholder: t('Carica un logo'),
                                            onChange: function(e) {
                                                return setLogoFile(e.target.files[0]);
                                            }
                                        }),
                                        ' ',
                                        LogoFile && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            style: {
                                                marginLeft: 10,
                                                maxWidth: 60,
                                                maxHeight: 50
                                            },
                                            className: "posizione__image",
                                            src: LogoFile ? URL.createObjectURL(LogoFile) : null
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "step-tailor__fieldsets",
                        style: {
                            marginTop: 25,
                            marginBottom: 25
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Data di consegna richiesta'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('inserisci data di consegna richiesta'),
                                    value: (ref32 = props.values) === null || ref32 === void 0 ? void 0 : ref32.data_consegna,
                                    onBlur: props.handleBlur('data_consegna'),
                                    onChange: props.handleChange('data_consegna')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                label: t('Prezzo target'),
                                status: ((ref33 = props.touched) === null || ref33 === void 0 ? void 0 : ref33.prezzo_target) && ((ref34 = props.errors) === null || ref34 === void 0 ? void 0 : ref34.prezzo_target) ? 'error' : ((ref35 = props.touched) === null || ref35 === void 0 ? void 0 : ref35.prezzo_target) && 'success',
                                errorMessage: (ref36 = props.errors) === null || ref36 === void 0 ? void 0 : ref36.prezzo_target,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                    placeholder: t('inserisci prezzo target'),
                                    value: (ref37 = props.values) === null || ref37 === void 0 ? void 0 : ref37.prezzo_target,
                                    onBlur: props.handleBlur('prezzo_target'),
                                    onChange: props.handleChange('prezzo_target')
                                })
                            })
                        ]
                    }),
                    !(service_gift === null || service_gift === void 0 ? void 0 : service_gift.attivo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "registrazione__template__disclaimer",
                        style: {
                            marginBottom: 16
                        },
                        children: [
                            t('Contattandoci, dichiari di aver letto e compreso'),
                            ' ',
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                style: {
                                    textDecoration: 'underline',
                                    fontWeight: 'bold'
                                },
                                href: getUrlInformativaFromStore(),
                                children: t("l'Informativa Privacy")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        label: t('Richiedi ordine'),
                        variant: "primary",
                        disabled: props.isValid ? false : true,
                        type: "submit",
                        onClick: function() {
                            return props.handleSubmit();
                        }
                    })
                ]
            });
        }
    }));
};
/* harmony default export */ var FormTailorMade_FormTailorMade = (FormTailorMade);

;// CONCATENATED MODULE: ./components/template/TailorMadeTemplate/TailorMadeTemplate.js






var TailorMadeTemplate = function(param) {
    var page = param.page;
    var width = (0,useWindowDimensions/* default */.Z)().width;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tailor-made",
        style: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    justifySelf: 'center',
                    alignSelf: 'center',
                    width: '80%',
                    marginTop: 50
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules/* Breadcrumbs */.Oo, {
                        breadcrumbs: page === null || page === void 0 ? void 0 : page.breadcrumbs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        style: {
                            textAlign: 'left'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                            chiave: "Ordini import - Articoli Tailor Made"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: page.main_image ? page.main_image : 'https://via.placeholder.com/728x90.png',
                style: {
                    width: '100%',
                    maxHeight: 300,
                    margin: '20px 0px'
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    justifySelf: 'center',
                    width: width > 600 ? '50%' : '80%'
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            textAlign: 'left'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                style: {
                                    marginBottom: 15
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                    chiave: "Articoli Tailor Made di importazione diretta"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tailor-made__section",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Ordini speciali di improtazione diretta,",
                                        ' ',
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "articoli personalizzati sulla base delle vostre idee ed esigenze."
                                        }),
                                        "Realizziamo anche articoli che non rientrano nel normale assortimento a catalogo, creati ad hoc per soddisfare specifiche esigenze del cliente e personalizzati direttamente in fase di produzione. Vuoi importare un prodotto? Sipec ti offre una soluzione chiavi in mano ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "in 3 semplici passaggi"
                                        }),
                                        ' '
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tailor-made__section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                                chiave: "1) Seleziona il prodotto"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                            chiave: "- dal catalogo/sito Sipec www.sipec.com"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                            chiave: "- oppure indicaci un prodotto a tua scelta"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tailor-made__section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                                    chiave: "2) Comunicaci le tue esigenze"
                                                })
                                            }),
                                            ' '
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                            chiave: "- quantit\xe0"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                            chiave: "- colore (tra quelli disponibili a catalogo o il tuo colore pantone)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                            chiave: "- logo"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                            chiave: "- tempi di consegna"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tailor-made__section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                                chiave: "3) Noi ti forniamo"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                            chiave: "- la quotazione"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                            chiave: "- il campione in formato digitale (o fisico)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                            chiave: "- la comunicazione di conferma ordine"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTailorMade_FormTailorMade, {})
                ]
            })
        ]
    }));
};
/* harmony default export */ var TailorMadeTemplate_TailorMadeTemplate = (TailorMadeTemplate);

;// CONCATENATED MODULE: ./pages/strumenti-servizi/tailor-made/index.js






var TailorMadePage = function(param) {
    var page = param.page;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.utente;
    }), utente = ref.utente, fetched = ref.fetched;
    if (fetched) {
        if (utente) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(TailorMadeTemplate_TailorMadeTemplate, {
                page: page
            }));
        } else {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalLogin/* default */.Z, {
                visible: true
            }));
        }
    } else {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}));
    }
};
var __N_SSP = true;
/* harmony default export */ var tailor_made = (TailorMadePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8942,9774,2888,179], function() { return __webpack_exec__(49469); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);